(function() {
    'use strict';

    var URLParametersTracking = {
        storageKey: 'utmData',
        expirationDays: 7, // 1 week

        init: function() {
            this.checkExpiration();
            this.checkURLParams();
        },

        isExpired: function(timestamp) {
            if (!timestamp) {
                return true;
            }
            var now = Date.now();
            var expirationTime = this.expirationDays * 24 * 60 * 60 * 1000; // Convert days to milliseconds
            return (now - timestamp) > expirationTime;
        },

        checkExpiration: function() {
            var stored = this.getStorageRaw();
            if (stored && stored._timestamp && this.isExpired(stored._timestamp)) {
                // Data is expired, clear it
                localStorage.removeItem(this.storageKey);
            }
        },

        getStorageRaw: function() {
            try {
                var stored = localStorage.getItem(this.storageKey);
                return stored ? JSON.parse(stored) : null;
            } catch (e) {
                console.warn('Error reading utmData from localStorage:', e);
                return null;
            }
        },

        getStorage: function() {
            var stored = this.getStorageRaw();
            if (!stored) {
                return {};
            }
            // Check expiration
            if (stored._timestamp && this.isExpired(stored._timestamp)) {
                localStorage.removeItem(this.storageKey);
                return {};
            }
            // Return data without the timestamp field
            var data = {};
            for (var key in stored) {
                if (key !== '_timestamp') {
                    data[key] = stored[key];
                }
            }
            return data;
        },

        setStorage: function(data) {
            try {
                // Add timestamp to the data
                var dataWithTimestamp = {};
                for (var key in data) {
                    dataWithTimestamp[key] = data[key];
                }
                dataWithTimestamp._timestamp = Date.now();
                localStorage.setItem(this.storageKey, JSON.stringify(dataWithTimestamp));
            } catch (e) {
                console.warn('Error saving utmData to localStorage:', e);
            }
        },

        getURLParam: function(key) {
            try {
                var url = new URL(window.location.href);
                var params = new URLSearchParams(url.search);
                var value = params.get(key);
                return value || null;
            } catch (e) {
                // Fallback for older browsers
                var regex = new RegExp('[?&]' + key + '=([^&#]*)');
                var match = window.location.search.match(regex);
                return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : null;
            }
        },

        updateParameter: function(saved, paramKey, urlValue) {
            var existingValue = saved[paramKey];
            var hasExistingValue = existingValue !== undefined && existingValue !== null && existingValue !== '';

            // If parameter not present in URL (null) - keep existing value
            if (urlValue === null) {
                return null;
            }

            // Convert urlValue to string and check if empty
            var urlValueStr = String(urlValue);
            if (urlValueStr.trim() === '') {
                return null;
            }

            // If no existing value, set the new value
            if (!hasExistingValue) {
                return urlValueStr;
            }

            // Convert both values to strings for comparison
            var existingStr = String(existingValue);
            var newStr = String(urlValue);

            // Compare values case-insensitively
            var existingLower = existingStr.toLowerCase().trim();
            var newLower = newStr.toLowerCase().trim();

            // If values are equivalent (case-insensitive), keep existing (no replacement)
            if (existingLower === newLower) {
                return null;
            }

            // If values are different, replace with new value (attribute to latest)
            return urlValueStr;
        },

        // Debug method to see all stored data including timestamp
        debug: function() {
            var raw = this.getStorageRaw();
            var clean = this.getStorage();
            console.log('Raw utmData (with timestamp):', raw);
            console.log('Clean utmData (without timestamp):', clean);
            return {
                raw: raw,
                clean: clean
            };
        },

        checkURLParams: function() {
            // Standard UTM parameters for A/B testing
            var utmSource = this.getURLParam('utm_source');
            var utmMedium = this.getURLParam('utm_medium');
            var utmCampaign = this.getURLParam('utm_campaign');
            
            // Additional custom parameters
            var utmChannel = this.getURLParam('utm_channel');
            var utmEvent = this.getURLParam('utm_event');
            var utmTerm = this.getURLParam('utm_term');
            var utmContent = this.getURLParam('utm_content');
            var klarSource = this.getURLParam('klar_source');

            var saved = this.getStorage();
            var updated = false;

            // Track standard UTM parameters
            if (utmSource !== null) {
                var newSource = this.updateParameter(saved, 'utm_source', utmSource);
                if (newSource !== null) {
                    saved.utm_source = newSource;
                    updated = true;
                }
            }

            if (utmMedium !== null) {
                var newMedium = this.updateParameter(saved, 'utm_medium', utmMedium);
                if (newMedium !== null) {
                    saved.utm_medium = newMedium;
                    updated = true;
                }
            }

            if (utmCampaign !== null) {
                var newCampaign = this.updateParameter(saved, 'utm_campaign', utmCampaign);
                if (newCampaign !== null) {
                    saved.utm_campaign = newCampaign;
                    updated = true;
                }
            }

            // Track additional UTM parameters
            if (utmTerm !== null) {
                var newTerm = this.updateParameter(saved, 'utm_term', utmTerm);
                if (newTerm !== null) {
                    saved.utm_term = newTerm;
                    updated = true;
                }
            }

            if (utmContent !== null) {
                var newContent = this.updateParameter(saved, 'utm_content', utmContent);
                if (newContent !== null) {
                    saved.utm_content = newContent;
                    updated = true;
                }
            }

            // Track custom parameters
            if (utmChannel !== null) {
                var newChannel = this.updateParameter(saved, 'channel', utmChannel);
                if (newChannel !== null) {
                    saved.channel = newChannel;
                    updated = true;
                }
            }

            if (utmEvent !== null) {
                var newEvent = this.updateParameter(saved, 'event', utmEvent);
                if (newEvent !== null) {
                    saved.event = newEvent;
                    updated = true;
                }
            }

            if (klarSource !== null) {
                var newKlarSource = this.updateParameter(saved, 'klar_source', klarSource);
                if (newKlarSource !== null) {
                    saved.klar_source = newKlarSource;
                    updated = true;
                }
            }

            var campaignId = this.getURLParam('campaign_id') || this.getURLParam('campaignid');
            if (campaignId !== null) {
                var newCampaignId = this.updateParameter(saved, 'campaign_id', campaignId);
                if (newCampaignId !== null) {
                    saved.campaign_id = newCampaignId;
                    updated = true;
                }
            }

            var utmId = this.getURLParam('utm_id');
            if (utmId !== null) {
                var newUtmId = this.updateParameter(saved, 'utm_id', utmId);
                if (newUtmId !== null) {
                    saved.utm_id = newUtmId;
                    updated = true;
                }
            }

            // Save if any updates were made (this will update the timestamp)
            if (updated) {
                this.setStorage(saved);
            } else {
                // If no updates were made but we have existing data, just update the timestamp
                // This preserves existing UTM data while refreshing the expiration
                var currentStorage = this.getStorageRaw();
                if (currentStorage && currentStorage._timestamp) {
                    // Update timestamp to extend expiration, but keep existing data
                    currentStorage._timestamp = Date.now();
                    localStorage.setItem(this.storageKey, JSON.stringify(currentStorage));
                } else if (!currentStorage) {
                    // Only create empty object if there's truly no data at all
                    // This is important for the audience rule check: !JSON.parse(localStorage.getItem('utmData'))
                    this.setStorage({});
                }
            }
        }
    };

    // Initialize immediately when script loads (don't wait for DOMContentLoaded)
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
        URLParametersTracking.init();
    }

    if (typeof window !== 'undefined') {
        // Check on popstate (browser back/forward)
        window.addEventListener('popstate', function() {
            URLParametersTracking.init();
        });

        // Expose globally for manual access if needed
        window.URLParametersTracking = URLParametersTracking;
    }
})();